import * as React from 'react'

import { colors } from '@flowwai-frontend/shared/style-guide'

import './styles.css'

interface LoaderProps {
   height?: number
   width?: number
   color?: string
   className?: string
   radius?: number
   strokeWidth?: number
}

const Loader = (props: LoaderProps) => {
   const {
      width = 30,
      height = 30,
      strokeWidth = 5,
      color = `${colors['blue-500']}`,
      radius = 20,
      className
   } = props

   return (
      <svg
         width={width}
         height={height}
         viewBox='25 25 50 50'
         strokeWidth={strokeWidth}
         className={`common-ring-loader ${className}`}
      >
         <circle cx='50' cy='50' r={radius} stroke={color} />
      </svg>
   )
}

export { Loader }
